module.exports = __webpack_public_path__ + "static/media/hero.93cb216d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/sussex-street-mixed-use/hero.jpg
// module id = 61
// module chunks = 0